import React from "react";

export default function (props) {
    const segmentSize = 2;
    const videoDuration = props.videoDuration;
    const videoCurrentTime = props.videoCurrentTime;
    const avrgBufferDuration = props.avrgBufferDuration;

    if (videoDuration === undefined || videoCurrentTime === undefined) {
        return null;
    }

    const timeToLive = videoDuration - videoCurrentTime;
    const redThresh = avrgBufferDuration + segmentSize*2;
    const yellowThresh = avrgBufferDuration + segmentSize;

    let msg = "-" + timeToLive.toFixed(1) + "s";
    let style = props.style || {};
    if (timeToLive > redThresh) {
        style.background = "rgba(255,0,0,0.5)";//red
    } else if (timeToLive > yellowThresh) {
        style.background = "rgba(255,255,0,0.5)";//yellow
    } else {
        style.background = "rgba(0,75,0,0.5)";//green
    }

    return (
        <div className="text-center" style={style}>
            {msg}
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/js/Liveness.js